import { proxy, ref } from "valtio";
export const internalStore = proxy({
    blocks: {},
    set(key, value) {
        internalStore[key] = (value ? ref(value) : value);
    },
});
